import React from 'react';

interface MessageActionsProps {
  messageId: string;
  messageContent: string;
  onEdit: (messageId: string) => void;
  onRegenerate: (messageId: string) => void;
  onFeedback: (messageId: string, sentiment: 'positive' | 'negative') => void;
}

const MessageActions: React.FC<MessageActionsProps> = ({
  messageId,
  messageContent,
  onEdit,
  onRegenerate,
  onFeedback
}) => {
  return (
    <div className="flex items-center gap-2 mt-2 opacity-0 group-hover:opacity-100 transition-opacity">
      <button
        onClick={() => onEdit(messageId)}
        className="text-xs text-gray-500 hover:text-blue-600 transition"
        title="Edit message"
      >
        ✏️ Edit
      </button>
      <button
        onClick={() => onRegenerate(messageId)}
        className="text-xs text-gray-500 hover:text-blue-600 transition"
        title="Regenerate response"
      >
        🔄 Regenerate
      </button>
      <div className="ml-auto flex gap-1">
        <button
          onClick={() => onFeedback(messageId, 'positive')}
          className="text-xs text-gray-500 hover:text-green-600 transition"
          title="Helpful"
        >
          👍
        </button>
        <button
          onClick={() => onFeedback(messageId, 'negative')}
          className="text-xs text-gray-500 hover:text-red-600 transition"
          title="Not helpful"
        >
          👎
        </button>
      </div>
    </div>
  );
};

export default MessageActions;
